import { createSelector } from '@reduxjs/toolkit';

export const getBrandsState = (state) => state.brands;

export const getBrands = createSelector(getBrandsState, (brandsState) => brandsState.data);
